import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const RightSidebar = ({
  isOpen,
  onClose,
  title,
  children,
  widthClass = "sm:w-[450px] md:w-[400px] lg:w-[450px]",
  contentPadding = "p-8",
  scrollable = true,
}) => {
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [isOpen]);

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[200]">
          {/* Overlay */}
          <motion.div
            onClick={onClose}
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.3 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="absolute inset-0 bg-black"
          />

          {/* Sidebar */}
          <motion.div
            initial={{ x: "100%" }} 
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{
              type: "tween",
              duration: 0.3,
              ease: "easeInOut",
            }}
            className={`absolute top-0 right-0 h-full w-full ${widthClass} bg-white shadow-2xl flex flex-col`}
          >
            {/* Header */}
            <div className="px-6 py-2 border-b flex justify-between items-center">
              <h3 className="text-lg font-bold text-gray-900">{title}</h3>
              <button
                onClick={onClose}
                className="p-1 hover:bg-gray-100 rounded-full"
              >
                ✕
              </button>
            </div>

            {/* Content */}
            <div className={`flex-1 flex flex-col ${scrollable ? "overflow-y-auto" : "overflow-hidden"} min-h-0 ${contentPadding}`}>
              {children}
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default RightSidebar;
